import { Typography } from "antd";
import styled from "styled-components";
import { TabbarComponent } from "../../../components";
import { FilteredWorkShops } from "./partials/filtered-workshops.partial";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  border-radius: 8px;
`;

const Title = styled(Typography.Title)`
  font-size: 24px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
`;

export function WorkShopsView() {
  return (
    <Container>
      <Title level={1}>Taller Sharksia</Title>

      <TabbarComponent
        tabs={[
          {
            key: "1",
            label: "Todos",
            children: <FilteredWorkShops activeTab={"all"} />,
          },
          {
            key: "2",
            label: "Pendientes",
            children: <FilteredWorkShops activeTab={"pending"} />,
          },
          {
            key: "3",
            label: "En proceso",
            children: <FilteredWorkShops activeTab={"on_progress"} />,
          },
          {
            key: "4",
            label: "Completados",
            children: <FilteredWorkShops activeTab={"completed"} />,
          },
        ]}
      />

      {/*  <SectionContainer>
        <WorkshopHeader>
          <div>
            <p>Aquí encontrarás información sobre el proceso...</p>
          </div>
        </WorkshopHeader>
        <WorkshopImage
          src="https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/under_contruction.png"
          alt="Taller"
        />
      </SectionContainer> */}
    </Container>
  );
}

export const ShowWorkshopsRoute = "/workshops";
